import type { AppRouteModule } from "/@/router/types";
import { LAYOUT } from "/@/router/constant";

const compositeGalleryRouter: AppRouteModule = {
  path: "/compositeGallery",
  name: "CompositeGallery",
  component: LAYOUT,
  redirect: "/compositeGallery/index",
  meta: {
    hideChildrenInMenu: false,
    icon: "ant-design:home-outlined",
    title: "综合图库",
    orderNo: 3,
  },
  children: [
    {
      path: "index",
      name: "CompositeGalleryIndex",
      component: () => import("/@/views/compositeGallery/index.vue"),
      meta: {
        title: "图片管理",
        hideMenu: false,
      },
    },
    {
      path: "tag",
      name: "CompositeGalleryTag",
      component: () => import("/@/views/compositeGallery/tag.vue"),
      meta: {
        title: "标签管理",
        hideMenu: false,
      },
    },
  ],
};

export default compositeGalleryRouter;
